import { resolveMediaUrl } from './mediaUrl';

const parseMegaMenuItem = (media) => {
  if (!media?.caption) {
    return null;
  }

  try {
    const parsed = JSON.parse(media.caption);
    return {
      title: parsed.title || '',
      subtitle: parsed.subtitle || '',
      to: parsed.url || '',
      icon: resolveMediaUrl(media.url),
    };
  } catch {
    return null;
  }
};

export const parseNavbarContent = (page) => {
  if (!page?.sections?.length) {
    return null;
  }

  const navbarSection = page.sections.find((section) => section.key === 'navbar');
  if (!navbarSection) {
    return null;
  }

  const fields = navbarSection.fields || {};
  const logoMedia =
    navbarSection.media?.primary ||
    navbarSection.media?.groups?.logo?.[0] ||
    null;

  const links = [];
  for (let index = 1; index <= 20; index += 1) {
    const label = fields[`link-${index}-label`];
    if (!label) {
      break;
    }

    links.push({
      label,
      to: fields[`link-${index}-url`] || '#',
      megaMenu: fields[`link-${index}-mega-menu`] || null,
      hasChevron: fields[`link-${index}-has-chevron`] === 'true',
    });
  }

  const megaMenus = {};
  page.sections
    .filter((section) => section.key.startsWith('navbar-mega-'))
    .forEach((section) => {
      const id = section.key.replace('navbar-mega-', '');
      const sectionFields = section.fields || {};
      const items = (section.media?.groups?.items || [])
        .map(parseMegaMenuItem)
        .filter(Boolean);

      megaMenus[id] = {
        title: sectionFields.title || '',
        description: sectionFields.description || '',
        url: sectionFields.url || '',
        items,
      };
    });

  return {
    logo: logoMedia
      ? {
          url: resolveMediaUrl(logoMedia.url),
          alt: logoMedia.altText || 'VBS',
        }
      : null,
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '',
    },
    links,
    megaMenus,
  };
};
